import { useEffect, useRef, useState } from 'react';
import { Palette, ChevronDown, Check } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import './ThemeSelector.css';

export default function ThemeSelector() {
  const { themes, currentTheme, selectTheme, saving } = useTheme();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onMouseDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  if (!themes.length) return null;

  const handleSelect = (themeId) => {
    setOpen(false);
    selectTheme(themeId);
  };

  return (
    <div className="theme-selector" ref={rootRef}>
      <button
        type="button"
        className="theme-selector-trigger"
        onClick={() => setOpen((o) => !o)}
        disabled={saving}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <Palette size={16} />
        <span className="theme-selector-trigger-text">Theme</span>
        <ChevronDown size={14} className={`theme-selector-chevron${open ? ' open' : ''}`} />
      </button>

      {open && (
        <div className="theme-selector-menu" role="menu">
          {themes.map((t, index) => {
            const active = t.themeId === currentTheme?.themeId;
            return (
              <button
                key={t.themeId}
                type="button"
                role="menuitemradio"
                aria-checked={active}
                aria-label={`Theme ${index + 1}: ${t.themeName}`}
                title={t.themeName}
                className={`theme-selector-option${active ? ' active' : ''}`}
                onClick={() => handleSelect(t.themeId)}
              >
                <span className="theme-selector-check">{active && <Check size={14} />}</span>
                <span className="theme-selector-name">Theme {index + 1}</span>
                <span className="theme-selector-swatch" style={{ backgroundColor: t.colorCode }} />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}